/* RESPONSIBLE TEAM: team-purchase */
import { type Router } from '@ember/routing';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class IntershopProductsProductPlansIndexRoute extends Route {
  @service declare router: Router;

  redirect(): void {
    this.router.transitionTo('apps.app.intershop');
  }
}
